import { NextRouter, useRouter } from 'next/router'
import { use } from 'react'

function waitForRouter(router: NextRouter) {
  let f: Function
  const promise = new Promise((resolve) => void (f = resolve))

  function loop() {
    if (router.isReady) f()
    else setTimeout(loop, 0)
  }

  loop()

  return promise
}

export function useReadyRouter() {
  const router = useRouter()
  if (!router.isReady) {
    use(waitForRouter(router))
  }

  return router
}
